import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box } from '@mui/material';
import NotFoundImage from '../assets/images/404.webp';
import CustomButton from '../components/Common/button';

const NotFound404 = () => {
  const navigate = useNavigate();

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      minHeight="80vh"
      textAlign="center"
      sx={{ padding: 4 }}>
      <Box
        component="img"
        src={NotFoundImage}
        alt="Page not found"
        sx={{
          width: '100%',
          maxWidth: 400,
          height: 'auto',
          mb: 2
        }}
      />
      <CustomButton title="Go to Home" onClick={() => navigate('/')} />
    </Box>
  );
};

export default NotFound404;
